module.exports = __webpack_public_path__ + "images/no-people-4774fa3dde92e69e69a61e3929fb5aea.png";